/** Route names that must render without a logged-in session / filterOptions. */
export const PUBLIC_AUTH_ROUTE_NAMES = ['login', 'forgotPassword', 'resetPassword']

export function isPublicAuthRoute(routeName) {
	return PUBLIC_AUTH_ROUTE_NAMES.includes(routeName)
}
